import React from 'react';

export default ({
  visibleWeek,
  currentWeek,
  onTodayPress,
  onLeftArrowClick,
  onRightArrowClick
}) => {
  return (
    <div className="sub-header-booking flex flex-col md:flex-row w-full sm:px-[2rem]">
      <h1 className="text-[2rem] sm:text-[3rem] md:text-[4.375rem] w-full sm:text-start">
        Бронювання корту
      </h1>
      <div className="sub-header__choose-day mt-8 md:mt-0 w-full md:justify-end justify-center">
        <div
          className={`sub-header__arrow js-arrow-previous o-btn o-btn__primary o-btn__circle ${
            visibleWeek <= currentWeek && 'disabled'
          }`}
          onClick={onLeftArrowClick}>
          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" fill="none">
            <path d="M8.267 15 1.733 8l6.534-7" stroke="#fff" strokeWidth="2" />
          </svg>
        </div>
        <div
          className={`sub-header__day o-btn o-btn__primary js-current-day !w-auto`}
          onClick={onTodayPress}>
          Сьогодні
        </div>
        <div
          className={`sub-header__arrow js-arrow-next o-btn o-btn__primary o-btn__circle ${
            visibleWeek >= currentWeek + 5 && 'disabled'
          }`}
          onClick={onRightArrowClick}>
          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" fill="none">
            <path d="m.733 1 6.534 7-6.534 7" stroke="#fff" strokeWidth="2" />
          </svg>
        </div>
      </div>
    </div>
  );
};
